<template>
  <v-inventory-create
    name="items discount"
    no-additional-cost
    ref="counts"
    :top_title="target == 'create' ? 'discount_create' : 'discount_update'"
    :noNote="true"
  >
    <v-layout row>
      <v-flex class="px-3" sm6>
        <v-text-field
          :label="$t('name')"
          v-model="params.name"
          ref="name"
          :rules="[fieldRules.required]"
        />
      </v-flex>
      <v-flex class="px-3" sm6>
        <v-autocomplete
          :label="$t('store')"
          multiple
          v-model="params.services"
          v-bind:items="services"
          item-text="name"
          item-value="_id"
          ref="service"
          :rules="[fieldRules.required]"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex class="px-3" md4 sm4>
        <DatePicker
          class="elevation-1 rounded text--black"
          v-model="params.start_time"
          :clearable="false"
          placeholder="Start date"
          :type="'datetime'"
          format="YYYY-MM-DD HH:mm"
          :showSecond="false"
          showMinute
          :minute-step="1"
          :disabled-date="notAfterToday"
          value-type="timestamp"
        />
      </v-flex>
      <v-flex class="px-3" md4 sm4>
        <DatePicker
          class="elevation-1 rounded text--black"
          v-model="params.end_time"
          :clearable="false"
          placeholder="End date"
          :type="'datetime'"
          format="YYYY-MM-DD HH:mm"
          :showSecond="false"
          showMinute
          :minute-step="1"
          :disabled-date="notAfterTodayAndNotBeforeStartDate"
          :default-value="new Date().setHours(23, 59, 59, 999)"
          value-type="timestamp"
        />
      </v-flex>
      <v-flex class="px-3 mt-n3" md4>
        <v-text-field
          :label="$t('discount')"
          v-model="params.value"
          ref="name"
          maxlength="3"
          :rules="[MaxValue]"
          suffix="%"
          @focus="$event.target.select()"
        />
      </v-flex>
    </v-layout>
    <template v-if="params.type == 'percentage'" #count_headers>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="addByCategory">Add By Category</v-btn>
      <v-btn color="primary" text @click="addBySupplier">Add By Supplier</v-btn>
    </template>
    <template #items>
      <template v-if="params.type == 'percentage'">
        <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          hide-default-footer
          :items-per-page="200000"
          :no-data-text="$t('you_have_not_selected_items_yet')"
        >
          <template #[`item.name`]="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.product_name }}</v-list-item-title>
              <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="item.barcode && item.barcode.length > 0"
              >
                Barcode
                <span v-for="(barcode, ind) in item.barcode" :key="ind">{{
                  barcode + ", "
                }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template #[`item.in_stock`]="{ item }">{{ item.in_stock }}</template>
          <template #[`item.remove`]="{ item }">
            <v-btn icon v-on:click="remove_item(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-divider />
        <v-card-text>
          <v-search-items
            v-bind:label="$t('add_item')"
            v-bind:items="items_list"
            v-bind:selectedAct="add_item"
            v-bind:rules="
              items && items.length == 0 ? [fieldRules.required] : []
            "
            v-bind:searchItems="getItems"
            v-bind:loading_inv_items="loading_inv_items"
          ></v-search-items>
        </v-card-text>
      </template>
      <template v-else>
        <v-card-text>All items will be counted.</v-card-text>
      </template>
    </template>
    <template #action>
      <v-btn v-on:click="cancel" text>{{ $t("cancel") }}</v-btn>
      <v-btn
        color="success"
        :loading="loading_discount"
        text
        v-on:click="save"
        :disabled="saveDisabled"
        >{{ target }}</v-btn
      >
    </template>
    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text"
          >This item has already been added</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_by_dialog" persistent width="800">
      <v-card tile>
        <v-spacer />
        <v-card-actions
          style="
            position: sticky;
            top: 0;
            z-index: 1100;
            background-color: #f6f5f7;
          "
          elevation="8"
        >
          <v-spacer />
          <v-btn text @click="add_by_dialog = false">Cancel</v-btn>
          <v-btn text color="primary" @click="addCountItem">Add</v-btn>
        </v-card-actions>
        <v-card-title>{{ add_by.title }}</v-card-title>
        <hr style="border: 0.5px dashed grey" />
        <v-layout row mx-4>
          <v-text-field
            v-model="search_item"
            autocomplete="off"
            color="black"
            placeholder="Search"
            prepend-icon="mdi-magnify"
          ></v-text-field>
        </v-layout>

        <hr style="border: 0.5px dashed grey" class="mt-0" />
        <v-card-text class="py-2 px-4">
          <v-layout row v-for="(itm, ind) in add_by.items" :key="ind">
            <v-flex md12 px-4>
              <v-layout>
                <v-flex md12>
                  <v-checkbox
                    :label="
                      add_by.type == 'category' ? itm.name : itm.supplier_name
                    "
                    v-model="add_by.selected[ind]"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md12>
                  <hr
                    v-if="add_by.items.length - 1 != ind"
                    style="border: 0.5px dashed grey"
                    class="mt-0"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>

        <hr
          v-if="add_by.items.length > 0"
          style="border: 0.5px dashed grey"
          class="mt-0"
        />
      </v-card>
    </v-dialog>
  </v-inventory-create>
</template>
<script>
import Services from "../../mixins/services";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/scss/index.scss";
let now = new Date();
export default {
  components: {
    DatePicker,
  },
  name: "TransferCreate",
  mixins: [Services],

  data: () => ({
    params: {
      service: null,
      type: "percentage",
      start_time: new Date(new Date().setDate(now.getDate())).getTime(),
      end_time: new Date(new Date().setDate(now.getDate())).getTime(),
      value: 0,
      name: "",
      services: [],
    },
    headers: [
      { text: "Item", value: "name" },
      // { text: "Expected stock", value: "in_stock", align: "right", width: 160 },
      { text: null, value: "remove", align: "right", width: 60 },
    ],
    items: [],
    items_list: [],
    item: null,
    exist_dialog: false,
    search_item: null,
    add_by: {
      type: -1,
      items: [],
      selected: [],
    },
    categories: [],
    suppliers: [],
    add_by_dialog: false,
    search_text: "123",
    loading_inv_items: false,
    loading_discount: false,
    MaxValue: (val) => {
      if (val > 100) return "Max 100";
      return true;
    },
  }),
  mounted() {
    this.headers = [
      { text: this.$t("item"), value: "name" },
      // {
      //   text: this.$t("expected_stock"),
      //   value: "in_stock",
      //   align: "right",
      //   width: 160,
      // },
      { text: null, value: "remove", align: "right", width: 60 },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.getCategoryAndSupplier();
    this.update();
  },
  computed: {
    target() {
      return this.$route.params["target"];
    },
    form() {
      return {
        service: this.params.service,
      };
    },
    saveDisabled() {
      let formHasErrors = false;
      if (
        this.items?.length != 0 &&
        this.params?.name != "" &&
        this.params?.value != 0 &&
        this.params?.services?.length != 0
      ) {
        formHasErrors == false;
      } else {
        formHasErrors = true;
      }
      return formHasErrors;
    },
  },
  watch: {
    "params.services"() {
      this.getItems(this.search_text, true);
      // this.itemsRefresh();
    },
    categories() {
      if (this.add_by.type == "category") {
        this.add_by.items = this.categories;
      }
    },
    suppliers() {
      if (this.add_by.type != "category") {
        this.add_by.items = this.suppliers;
      }
    },
    "add_by.items"() {
      this.add_by.selected = [];
    },
    add_by_dialog() {
      this.search_item = "";
    },
    search_item() {
      this.searchItems();
    },
  },
  methods: {
    notAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        date >= (this.params.end_time !== null ? this.params.end_time : today)
      );
    },
    notAfterTodayAndNotBeforeStartDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < this.params.start_time - 86400000;
    },
    async addByCategory() {
      this.add_by_dialog = true;
      this.add_by.type = "category";
      this.add_by.items = this.categories;
    },
    async addBySupplier() {
      this.add_by_dialog = true;
      this.add_by.type = "supplier";
      this.add_by.items = this.suppliers;
    },
    async getCategoryAndSupplier() {
      const categories = this.$communicator.then(
        this,
        await this.$communicator("list_of_top_categories")
      );
      this.categories = categories;
      const suppliers = this.$communicator.then(
        this,
        await this.$communicator("all_suppliers")
      );
      this.suppliers = suppliers;
    },
    searchItems() {
      this.add_by.items = [];
      if (this.add_by.type == "category") {
        for (const cat of this.categories) {
          if (cat.name.toLowerCase().includes(this.search_item.toLowerCase())) {
            this.add_by.items.push(cat);
          }
        }
      } else {
        for (const cat of this.suppliers) {
          if (
            cat.supplier_name
              .toLowerCase()
              .includes(this.search_item.toLowerCase())
          ) {
            this.add_by.items.push(cat);
          }
        }
      }
    },
    async addCountItem() {
      const query = [];
      for (const itm in this.add_by.selected) {
        query.push(this.add_by.items[itm]._id);
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_inv_count_items", {
          params: {
            service: this.params.service,
            categories: this.add_by.type == "category" ? query : [],
            suppliers: this.add_by.type != "category" ? query : [],
          },
        })
      );
      const ITEMS = this.items;
      for (const item of items) {
        let exist = false;
        for (const itm of this.items) {
          exist = exist || item._id == itm.product_id;
        }
        if (!exist) {
          let search_text = item.name + item.sku;
          if (item.barcode && typeof item.barcode == typeof []) {
            for (const b of item.barcode) {
              search_text += b;
            }
          }
          ITEMS.push({
            product_id: item._id,
            product_name: item.name,
            in_stock: item.in_stock,
            sku: item.sku,
            barcode: item.barcode,
            search_text: search_text,
          });
        }
      }
      this.items = ITEMS;
      this.add_by_dialog = false;
    },
    add_item(item) {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id == item.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_dialog = true;
      } else {
        this.items.push(this.$copy(item));
      }
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    cancel() {
      if (this.target == "create") {
        this.$router.push({ path: "/items/promotions" });
      } else {
        this.$router.push({
          path: "/items/promotions",
          query: this.$route.query,
        });
      }
    },
    async getItems(search, service_changed) {
      if (typeof search != typeof "invan") {
        search = "";
      }
      if (this.search_text == search && !service_changed) {
        return;
      }
      this.search_text = search;
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_inv_count_items", {
          arguments: [50, 1],
          params: {
            service: this.params.service,
            search: search,
            categories: [],
            suppliers: [],
          },
        })
      );
      if (items) {
        var items_list = [];
        const inStockMap = {};
        for (const index in items) {
          let search_text =
            items[index].name +
            this.converter(items[index].name) +
            items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          inStockMap[items[index]._id] = items[index].in_stock;
          items_list.push({
            product_id: items[index]._id,
            product_name: items[index].name,
            in_stock: items[index].in_stock,
            sku: items[index].sku,
            barcode: items[index].barcode,
            search_text: search_text,
          });
        }
        this.items_list = items_list;
      }
    },
    async itemsRefresh() {
      const ids = [];
      for (const itm of this.items) {
        ids.push(itm.product_id);
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("inv_items_refresh", {
          params: {
            service: this.params.service,
            indexes: ids,
          },
        })
      );
      if (items) {
        const itemsMap = {};
        for (const itm of items) {
          itemsMap[itm._id] = itm;
        }
        for (const ind in this.items) {
          if (itemsMap[this.items[ind].product_id]) {
            this.items[ind].in_stock =
              itemsMap[this.items[ind].product_id].in_stock;
          }
        }
      }
    },
    async update() {
      if (this.target == "update") {
        const transfer = this.$communicator.then(
          this,
          await this.$communicator("promotion_get_id", {
            arguments: [this.$route.query["id"]],
          })
        );
        if (transfer) {
          this.$refs["counts"].init(transfer);
          this.params.name = transfer.name;
          this.params.value = transfer.value;
          this.params.services = [];
          for (const ser of transfer.services) {
            if (ser.available == true) {
              this.params.services.push(ser.service);
            }
          }
          this.params.type = transfer.type;
          this.params.start_time = transfer.start_time;
          this.params.end_time = transfer.end_time;
          if (transfer.type == "percentage") {
            for (const index of transfer.items) {
              this.items.push({
                sku: index.sku,
                product_id: index.product_id,
                product_name: index.product_name,
                barcode: index.barcode,
              });
            }
          }
        }
      }
      this.getItems();
    },
    async save() {
      this.loading_discount = true;
      var params = this.$copy(
        Object.assign(this.params, this.$refs["counts"].options())
      );
      params.start_time = new Date(params.start_time).getTime();
      params.end_time = new Date(params.end_time).getTime();
      if (params.type == "percentage") {
        var items = [];
        for (const index in this.items) {
          items.push({
            sku: this.items[index]?.sku,
            product_id: this.items[index]?.product_id,
            product_name: this.items[index]?.product_name,
            barcode: this.items[index]?.barcode,
          });
        }
        params.items = items;
      }
      if (this.target == "create") {
        const response = this.$communicator.then(
          this,
          await this.$communicator("promotion_create", {
            params: params,
          })
        );
        if (response.statusCode == 422) {
          this.$toast.error("Error", { timeout: 2000 });
        } else if (response.statusCode == 411) {
          this.$toast.error(`${response.message}`, { timeout: 2000 });
        } else {
          this.$toast.success("Success", { timeout: 2000 });
        }
        this.$router.push({
          path: "/items/promotions",
          query: {
            id: response?._id,
          },
        });
      } else {
        await this.$communicator("promotion_update", {
          arguments: [this.$route.query["id"]],
          params: params,
        });
        this.$toast.success("Success", { timeout: 2000 });
        this.$router.push({
          path: "/items/promotions",
          query: this.$route.query,
        });
      }
      this.loading_discount = false;
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
<style lang="scss">
@import "~vue2-datepicker/scss/var.scss";
@import "~vue2-datepicker/scss/icon.scss";
@import "~vue2-datepicker/scss/btn.scss";
@import "~vue2-datepicker/scss/scrollbar.scss";
@import "~vue2-datepicker/scss/animation.scss";

.width100 {
  width: 160px !important;
}
.width200 {
  min-width: 160px !important;
}

@media (min-width: 1537px) {
  .width100 {
    min-width: 245px;
  }
  .width200 {
    min-width: 400px;
  }
}

.#{$namespace}-datepicker {
  position: relative;
  display: inline-block;
  width: 400px;
  svg {
    width: 1.2em;
    height: 1.2em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
}

.#{$namespace}-datepicker-range {
  width: 320px;
}

.#{$namespace}-datepicker-inline {
  width: auto;
}
</style>